/**
* Created by kongwm.kong on 2017/7/20.
*/
<template>
    <div class="regSucc_page_wrap">
        <div class="layout_n">
            <div class="reg_succ">
                <div class="title">注册成功！</div>
<!--                <p class="ps">注：请于14日内登录系统并完成产品承诺函上传操作，<br>否则账号将会被回收。</p>-->
                <div class="btn"><router-link to="/login">前往登录</router-link></div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'basic-example',
        // 注册组件
        components: {

        },
        data (){
            return {
                username:'',
                password:''
            }
        },
        mounted: function (){
        },
        methods: {

        },
        watch:{

        }
    };
</script>
<style lang="scss" type="text/scss" scoped>
.regSucc_page_wrap{
    margin-top:30px;
    margin-bottom:50px;
    .reg_succ{
        background: #fff;
        height:700px;
        padding-top:130px;
        text-align: center;
        .title{
            font-size: 22px;
            color: $btn_408;
            letter-spacing: 0;
            line-height: 22px;
            margin-bottom: 24px;
        }
        .ps{
            width:383px;
            margin: 0 auto;
            color:$c_ff5;
            font-size: 16px;
            opacity: 0.98;
            letter-spacing: -0.39px;
            line-height: 24px;
            margin-bottom:40px;

        }
        .btn{
            width:330px;
            margin: 0 auto;
            height:40px;
            background: $btn_408;
            text-align:center;
            font-size:18px;
            color:#fff;
            font-weight:bold;
            line-height:40px;
            cursor: pointer;
            a{
                display: block;
                width:100%;
                height:100%;
                color: #fff;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/user/regSucc.vue